import { useState, useCallback } from 'react';

export function useFormValidation(initialErrors = {}) {
  const [errors, setErrors] = useState(initialErrors);

  const validateField = useCallback((name, value, validationFn) => {
    const error = validationFn(value);
    setErrors(prev => ({ ...prev, [name]: error }));
    return !error; // Returns true if valid
  }, []);

  const validateFields = useCallback((fields) => {
    const newErrors = {};
    let isValid = true;

    Object.entries(fields).forEach(([name, { value, validation }]) => {
      if (validation) {
        const error = validation(value);
        if (error) {
          newErrors[name] = error;
          isValid = false;
        }
      }
    });

    setErrors(newErrors);
    return isValid;
  }, []);

  const clearError = useCallback((name) => {
    setErrors(prev => ({ ...prev, [name]: '' }));
  }, []);

  const clearAllErrors = useCallback(() => {
    setErrors({});
  }, []);

  return {
    errors,
    validateField,
    validateFields,
    clearError,
    clearAllErrors,
    setErrors
  };
}